import React from 'react';
import AppHeader from '../../Layout/AppHeader';
import { useActiveTab } from '../../../hooks';
import { usePendingBookings } from '@/hooks/usePendingBookings';
import { ImpersonationBanner } from '@/components/ImpersonationBanner';
import './AppLayout.css';

interface AppLayoutProps {
  children: React.ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  // Используем хук для определения активного таба по текущему пути
  const activeTab = useActiveTab();
  const { pendingCount, openModal } = usePendingBookings();
  
  return (
    <div className="app-layout" data-testid="app-layout">
      <AppHeader 
        activeTab={activeTab} 
        pendingBookingsCount={pendingCount}
        onPendingBookingsClick={openModal}
      />
      <ImpersonationBanner />
      <main className="app-layout__content" data-testid="main-content">
        {children}
      </main>
    </div>
  );
};

export default AppLayout;
